module.exports = __webpack_public_path__ + "static/media/bookmark.4fc68fe2.svg";